module.exports = __webpack_public_path__ + "img/master-card-dark_x2.b9a2da08.svg";